import { useOktaAuth } from "@okta/okta-react";
import { getEnvVars } from "../../config/env";

let setUserInfo: (_userInfo: IUserInfo) => void;
const userInfoPromise = new Promise<IUserInfo>((resolve) => {
  setUserInfo = resolve;
});
window.getUserInfo = () => userInfoPromise;

export const mockUser: IUserInfo = {
  name: "Mock User",
  email: "mockUser@thoughtworks.com",
  employeeId: "11111",
};

export function useAuthUserInfo() {
  const oktaContext = useOktaAuth();

  function setUserInfoIntoWindowObject(userInfo: IUserInfo) {
    if (!window.userInfo || !window.userInfo.employeeId) {
      window.userInfo = userInfo;
      window.dispatchEvent(new CustomEvent(
        "UserInfoAvailable",
        { detail: userInfo },
      ));
      setUserInfo?.(userInfo);
    }
  }

  return {
    async getUser() {
      let userInfo: IUserInfo = mockUser;
      if (!getEnvVars().disableOktaAuth) {
        const { name, email } = await oktaContext.oktaAuth.getUser();
        userInfo = { name: name!, email: email!, employeeId: null };
      }
      setUserInfoIntoWindowObject(userInfo);
      return userInfo;
    },
    setUserInfoIntoWindowObject,
  };
}
